import { RArray } from "../../collections";
import { DaySecond, TimeRange, WEEKDAY_NAMES, } from "../../core";
import { makeImmutable } from "../../core/makeImmutable";
import { DailySchedule } from "../DailySchedule";
export function makeDailyScheduleMap(factory) {
    const entries = WEEKDAY_NAMES.map((weekdayName) => [
        weekdayName,
        factory(weekdayName),
    ]);
    return Object.fromEntries(entries);
}
/**
 * Time schedule for each day of the week.
 *
 * For example: "9:00 - 16:00 on Monday, 6:00 - 16:00 from Thursday to Saturday, 9:00 - 11:00 and 13:00 - 15:00 on Sunday"
 */
export class WeeklySchedule {
    constructor(params) {
        this.dailySchedules = params;
        makeImmutable(this);
    }
    static fromWeeklyAvailability(availability) {
        const dailyScheduleMap = makeDailyScheduleMap((dayOfWeek) => {
            const dailyAvailability = availability[dayOfWeek.toLowerCase()];
            if (dailyAvailability.length !== 0) {
                return DailySchedule.fromRanges(dailyAvailability.map(({ from, to }) => TimeRange.fromRange({
                    from: DaySecond.fromNumber(from),
                    to: DaySecond.fromNumber(to),
                })));
            }
            return DailySchedule.empty();
        });
        return new WeeklySchedule(dailyScheduleMap);
    }
    static empty() {
        const emptySchedule = makeDailyScheduleMap(() => DailySchedule.empty());
        return new WeeklySchedule(emptySchedule);
    }
    static full() {
        const fullSchedule = makeDailyScheduleMap(() => DailySchedule.full());
        return new WeeklySchedule(fullSchedule);
    }
    get isEmpty() {
        return WEEKDAY_NAMES.every((weekday) => this.dailySchedules[weekday].isEmpty);
    }
    get isFull() {
        return WEEKDAY_NAMES.every((weekday) => this.dailySchedules[weekday].isFull);
    }
    dayOfWeek(weekday) {
        return this.dailySchedules[weekday];
    }
    includes(date) {
        return this.dailySchedules[date.weekday].includes(date);
    }
    rangesAround(date) {
        return new RArray(this.dailySchedules[date.weekday].timeRanges);
    }
    intersection(other) {
        const intersectedSchedule = makeDailyScheduleMap((weekdayName) => this.dailySchedules[weekdayName].intersection(other.dailySchedules[weekdayName]));
        return new WeeklySchedule(intersectedSchedule);
    }
}
